@if (mode() === taskTimerMode.column) {
  <div class="flex flex-col">
    <div class="flex items-center justify-center">
      @if (!taskTimer?.isStarted) {
        @if (iconSize() === 'large') {
          <mat-icon
            (click)="toggleTimer()"
            fontIcon="play_circle"
            class="cursor-pointer icon-3xl icon-success"
          />
        } @else {
          <mat-icon
            (click)="toggleTimer()"
            fontIcon="play_circle"
            class="cursor-pointer icon-success"
          />
        }
      } @else {
        <div class="flex items-center gap-2">
          @if (iconSize() === 'large') {
            <div
              (click)="toggleTimer()"
              class="flex items-center justify-center w-[60px] h-[60px] animate-pulse bg-proffeo-danger rounded-full cursor-pointer"
            >
              <div class="w-[30px] h-[30px] bg-proffeo-surface rounded-sm"></div>
            </div>
          } @else {
            <div
              (click)="toggleTimer()"
              class="flex items-center justify-center w-5 h-5 animate-pulse bg-proffeo-surface rounded-full border border-proffeo-danger cursor-pointer"
            >
              <mat-icon
                fontIcon="stop_circle"
                class="icon-danger material-symbols-filled"
              />
            </div>
          }
          @if (passingTime(); as timerTime) {
            <span class="text-[45px]">{{ timerTime }}</span>
          }
        </div>
      }
    </div>
  </div>
}

@if (mode() === taskTimerMode.row) {
  <div class="flex items-center gap-1">
    @if (showIcon()) {
      <div class="proffeo-col-xxs">
        @if (!taskTimer?.isStarted) {
          <mat-icon
            (click)="toggleTimer()"
            fontIcon="play_circle"
            class="cursor-pointer icon-success"
          />
        } @else {
          <div
            (click)="toggleTimer()"
            class="flex items-center justify-center w-[25px] h-[25px] animate-pulse bg-proffeo-feedback-danger-surface rounded-full border border-proffeo-danger cursor-pointer"
          >
            <mat-icon
              fontIcon="stop_circle"
              class="icon-md icon-danger material-symbols-filled"
            />
          </div>
        }
      </div>
    }

    <ng-container *ngTemplateOutlet="timer"></ng-container>
  </div>
}

@if (mode() === taskTimerMode.topBar && taskTimer) {
  <div class="flex gap-3.5 items-center">
    <div
      class="flex items-center justify-center w-5 h-5 animate-pulse bg-proffeo-surface rounded-full border border-proffeo-danger"
    >
      <mat-icon
        fontIcon="stop_circle"
        class="icon-md icon-danger material-symbols-filled"
      />
    </div>
    <div class="flex gap-1">
      <p class="text-proffeo-on-action hidden sm:flex text-sm">{{ 'timer.current-session' | translate }}:</p>
      <div class="flex items-center w-[55px]">
        @if (passingTime(); as timerTime) {
          <p class="text-proffeo-on-action text-sm">{{ timerTime }}</p>
        } @else {
          <p class="text-proffeo-on-action text-sm">00:00</p>
        }
      </div>
    </div>
  </div>
}

@if (mode() === taskTimerMode.readonly) {
  <div class="flex min-w-0 items-center w-full">
    <p class="min-w-0 truncate">
      {{ summaryTime() ? (summaryTime() | intlDuration) : '00:00' }}
      @if (estimation()) {
        <span>/ {{ estimation() | intlDuration }}</span>
      }
    </p>
  </div>
}

<ng-template #timer>
  <div
    (click)="toggleTimer()"
    class="flex items-center cursor-pointer"
  >
    @if (passingTime(); as timerTime) {
      <span class="text-base">{{ timerTime }}</span>
    } @else {
      <span class="text-base">{{ alreadyUsedTimeSpanValue }}</span>
    }
  </div>
</ng-template>
